import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensary from 'src/dispensary/hooks/use-dispensary';

const CONCIERGE_CUSTOM_NAME_ROLLOUT_FLAG = 'ecomm.concierge.custom-name.rollout';

export type DispensaryWithConciergeName = {
  webCustomizationSettingsV2?: { concierge?: { displayName?: string | null } | null } | null;
};

/**
 * The store's trimmed Virtual Budtender name, only when the custom-name rollout flag is on.
 * Reads from the passed dispensary when given, otherwise from `useDispensary()`.
 */
export function useConciergeDisplayName(dispensaryProp?: DispensaryWithConciergeName | null): string | undefined {
  const flags = useFlags();
  const { dispensary: hookDispensary } = useDispensary();
  if (!flags[CONCIERGE_CUSTOM_NAME_ROLLOUT_FLAG]) return undefined;

  const dispensary = dispensaryProp ?? hookDispensary;
  const name = dispensary?.webCustomizationSettingsV2?.concierge?.displayName?.trim();
  return name === '' ? undefined : name;
}
